module.exports = require("@seddi/math");